import './styles/global.css';
import './styles/bloomberg-override.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import App from './App';

const rootEl = document.getElementById('root')!;

console.log('[HYPER-ORACLE] main.tsx loaded, mounting React...');

try {
  const loadingEl = document.getElementById('loading-indicator');
  if (loadingEl) loadingEl.remove();

  const root = createRoot(rootEl);
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  );
  console.log('[HYPER-ORACLE] React render() called successfully');

  try {
    const x = new XMLHttpRequest();
    x.open('POST', '/api/client-error', true);
    x.setRequestHeader('Content-Type', 'application/json');
    x.send(JSON.stringify({ phase: 'REACT_MOUNTED', detail: 'render() called' }));
  } catch (_) {}
} catch (err: any) {
  console.error('[MOUNT FAILED]', err);
  rootEl.innerHTML = `
    <div style="color:#ef4444;padding:40px;font-family:monospace;font-size:13px;background:#080810;min-height:100vh;overflow:auto">
      <h2 style="color:#ef4444;margin-bottom:16px;font-weight:400;letter-spacing:3px">BOOTSTRAP FOUT</h2>
      <p style="color:rgba(255,255,255,0.55);margin-bottom:16px">${String(err?.message || err)}</p>
      <pre style="color:rgba(255,255,255,0.4);background:rgba(255,255,255,0.04);padding:16px;border-radius:8px;white-space:pre-wrap;word-break:break-all">${String(err?.stack || '')}</pre>
      <button onclick="window.location.reload()" style="margin-top:20px;padding:10px 24px;background:rgba(255,255,255,0.08);color:rgba(255,255,255,0.65);border:none;border-radius:6px;cursor:pointer;font-size:12px;letter-spacing:2px">HERSTART</button>
    </div>
  `;
}
